import { render, staticRenderFns } from "./OnboardingTermsAndConditions.vue?vue&type=template&id=1685b63c&scoped=true"
import script from "./OnboardingTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./OnboardingTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./OnboardingTermsAndConditions.vue?vue&type=style&index=0&id=1685b63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685b63c",
  null
  
)

export default component.exports